import { IReduxAction } from '../../../services/interfaces/common-interface';
import { GET_SUCCESS, SET_LOADING_DATA, SET_LOADING_SEND, RELOAD_SUCCESS } from './configuration-constants';

const INITIAL_STATE: any = {
  loadingData: false,
  loadingSend: false,
  taxation: false,
  acceptNegativeBalance: false,
  acceptDiscountDelivery: false,
  acceptBlockedSale: false,
  acceptSaleWithoutStock: false,
  minimumMargin: 0,
  maximumSalePercentage: 0,
  radiusVisit: 0,
  stayLength: 0,
  pointsAccelerator: [0, 0, 0, 0, 0],
  conversionFactorGift: 0,
  pointsFactorRewardValue: 0,
  minimumOrderValue: 0,
  tradingFinancialIncrease: [],
  marginControl: []
};

const configurationReducer = (state = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }
    case GET_SUCCESS: {
      return {
        ...action.payload
      };
    }

    case RELOAD_SUCCESS: {
      return {
        ...action.payload
      };
    }

    default:
      return state;
  }
};

export default configurationReducer;
